<template>
  <div>
   <!-- 表格 -->
    <div id="tablearea" class="table-area">
      <el-table
        v-if="isTable"
        ref="table"
        :empty-text="emptyText"
        :border="tableBorder"
        :height="height"
        :max-height="maxHeight"
        :size="tableSize"
        :data="tableData"
        :stripe="stripe"
        :cell-style="cellStyle"
        highlight-current-row
        :show-summary="showSummary"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @select-all="selectAll"
        @select="selectCheck"
        @row-dblclick="rowDbclick"
        @cell-click="cellClick"
        @row-click="rowClick"
        @selection-change="handleSelectionChange"
      >
       <slot name="tableSelection"></slot>
       <template v-for="(column,index) in columns">
        <el-table-column
        :show-overflow-tooltip="true"
        v-if="!column.iif"
        :key="index"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :class-name="column.className">
        <template  slot-scope="scope">
        <slot v-if="column.render" :name="column.render" v-bind:row="scope.row"></slot>
        <template v-else>{{scope.row[column.prop]}}</template>
        </template>
      </el-table-column>
       </template>

      </el-table>
    </div>
    <!-- 分页 -->
    <div :style="fenyeStyle" class="pagination-container" v-if="isPagination">
        <div>&nbsp;&nbsp;&nbsp;
            <slot name="footerSelect" />
        </div>
      <el-pagination
        :current-page.sync="table.pageNum"
        :page-size="table.pageSize"
        :total="table.count"
        :page-sizes="pageSizes"
        layout="total,prev,pager,next"
        background
        class="pagination"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </div>
  </div>
</template>

<script>
export default {
      name:"st",
      props:{
      tableBorder: {
          type: Boolean,
          default: true
      },
      tableData:{
        type:Array,
        required: true,
        default:[]
      },
      columns:{
        type:Array,
        required: true,
        default:[]
      },
      // 传入的表格数据
        table: {
            type: Object,
            default: () => ({
                data: [], // 数据
                page: 1, // 当前页数
                limit: 10, // 一页显示数量
                count: 0 // 总数量
            })
        },
      cellStyle:{
        type: Function,
        default: (param) => { },
      },
        // 斑马纹表格
        stripe: {
            type: Boolean,
            default: false
        },
        // 竖直方向边框
        border: {
            type: Boolean,
            default: false
        },
        // 总计行
        showSummary: {
            type: Boolean,
            default: false
        },
        // 总计方法
        summaryMethod: {
            type: Function,
            default: (param) => { },
        },
        // 全部展开
        expandAll: {
            type: Boolean,
            default: false
        },
        // 默认展开的行的id
        expandRowKeys: {
            type: Array,
            default: () => []
        },
        isPagination:{
            type:Boolean,
            default:true
        },
        // 自动分页
        autoPaging: {
            type: Boolean,
            default: false
        },
        // 分页style
        fenyeStyle: {
            type: Object
        },
        // 分页数设置
        pageSizes: {
            type: Array,
            default: () => [10, 20, 30, 40]
        },
        loading:{
            default:false,
        },
        // 是否表格
        isTable: {
            type: Boolean,
            default: true
        },
        heightTable:{
            type:String,
            default:"",
        },
        maxHeight:{
            type:String,
            default:'300px'
        },
        size:{
            type:String,
            default:"",
        }
    },
      data() {
          return {
                height:270,
          }
      },
     computed: {
        // 返回表格选择项
        selection() {
            if (this.isTable) {
                return this.$refs.table.selection
            }
            return this.$refs.cardTable.selection
        },
        // 根据分辨率控制表格大小
        tableSize() {
            // if(this.size){
            //     return this.size;
            // }
            // const screenWidth = window.screen.width
            // if (screenWidth > 1920) {
            //     return 'large'
            // }
            // if (screenWidth <= 1920 && screenWidth > 1680) {
                return 'medium'
            // }
            // if (screenWidth <= 1680 && screenWidth >= 1367) {
            //     return 'small'
            // }
            // return 'mini'
        },
        emptyText(){
            if(this.loading){
                return "正在加载中..."
            }else{
                return "暂无数据"
            }
        }
    },
    watch: {
        // 数据变化时表格滑动到最顶端
        tableData: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    if (this.isTable) {
                        this.$refs.table.bodyWrapper.scrollTop = 0
                    } else {
                        this.$refs.cardTable.scrollTop = 0
                    }
                }
            }
        },
    },
    mounted() {
        this.clientHeight()
    },

    updated() {
        if (this.autoPaging) {
            this.table.count = this.table.data.length
        }
    },
    methods: {
         selectAll(select){
           this.$emit("select-all",select)
         },
         selectCheck(selection, row){
            this.$emit("select",selection, row)
         },
         clientHeight(){
            //重新渲染表格样式，防止表格样式错乱
            this.$nextTick(()=>{
             this.$refs.table && this.$refs.table.doLayout()
            })
            if(!this.heightTable){
               this.myUtils.tableHeight(this)
            }else{
                this.$nextTick(() => {
                     this.height=this.heightTable
                })

            }
         },
        // 全选
        toggleAllSelection() {
            if (this.isTable) {
                this.$refs.table.toggleAllSelection()
            } else {
                this.$refs.cardTable.toggleAllSelection()
            }
        },
        handleSelectionChange(val){
            this.$emit("selection-change",val)
        },
        // 换页
        changePage(e) {
            if (this.autoPaging) {
                // eslint-disable-next-line vue/no-mutating-props
                this.table.page = e
            } else {
                // eslint-disable-next-line vue/custom-event-name-casing
                this.$emit('changePage', e)
                this.table.pageNum = e;
                // this.$emit('getData', e);
            }
        },
        // 更换每页显示数量
        changeSize(e) {
            if (!this.autoPaging) {
                // eslint-disable-next-line vue/custom-event-name-casing
                this.$emit('changeSize', e)
              this.table.pageSize = e;
            //   this.$emit('getData', e);
            } else {
                // eslint-disable-next-line vue/no-mutating-props
                this.table.page = 1
                // eslint-disable-next-line vue/no-mutating-props
                this.table.limit = e
            }
        },
        cellClick(row, column, cell, event) {
            this.$emit('cell-click', row, column, cell, event)
        },
        rowDbclick(row, column, event) {
            this.$emit('row-dblclick', row, column, event)
        },
        rowClick(row, column, event) {
          this.$emit('row-click', row, column, event)
        }
    }
}

</script>
<style lang='less' scoped>
.cb__drug-search-box{
    .pagination-container{
    background:#FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border:1px solid #EBEEF5;
    border-top:none
}
.pagination{
    border:none
}
}
</style>



// WEBPACK FOOTER //
// src/components/cloud-clinic/components/SimpleTable.vue